<ion-content>
	<div class="bg-image"></div>
	<div class="blur"></div>

	<div class="center-block">
		<h1 class="text-centered">
			{{ "GLOBAL_WELCOME" | translate }}!
		</h1>
		<button ion-button *ngIf="!sessionService.isLoged" (click)="onLogin()">Login</button>
		<button ion-button *ngIf="!tabsLauncherService.hasData && appDetector.isTournamentApp()" (click)="onNewTournament()">
			{{'NEW_TOURNAMENT' | translate }}
		</button>
		<button ion-button *ngIf="!tabsLauncherService.hasData && appDetector.isLeaderBoardApp()" (click)="onNewTournament()">
			{{'NEW_EVENT' | translate }}
		</button>
	</div>
</ion-content>
